import React from "react";
import Background from "../../assets/login-background.png";

const styles = {
  wrapper: {
    minHeight: "100vh",
    backgroundColor: "#0f172a",
    backgroundImage: `url("${Background}")`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundPosition: "center center",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "24px",
  },
  panel: {
    background: "#FEF3C7",
    border: "1px solid #FBBF24",
    borderRadius: "12px",
    padding: "32px",
    maxWidth: "520px",
    width: "100%",
    textAlign: "center",
    color: "#92400E",
  },
  title: {
    margin: "0 0 12px",
    fontSize: "20px",
  },
  message: {
    margin: "0 0 20px",
    lineHeight: "1.5",
    fontSize: "14px",
  },
  button: {
    background: "#92400E",
    border: "none",
    borderRadius: "999px",
    color: "#FEF3C7",
    cursor: "pointer",
    fontSize: "13px",
    padding: "8px 18px",
  },
  buttonDisabled: {
    opacity: 0.6,
    cursor: "not-allowed",
  },
};

const SystemStatusScreen = ({ variant, onRetry, isRetrying }) => {
  const isOffline = variant === "offline";
  const title = isOffline
    ? "Nema internetske veze"
    : "Tehničke poteškoće";
  const message = isOffline
    ? "Izgleda da vaše računalo nije spojeno na internet. Provjerite vezu pa pokušajte ponovno."
    : "Trenutno se suočavamo s tehničkim poteškoćama. Molimo pokušajte kasnije.";

  return (
    <div style={styles.wrapper}>
      <div style={styles.panel}>
        <h1 style={styles.title}>{title}</h1>
        <p style={styles.message}>{message}</p>
        {onRetry && (
          <button
            type="button"
            onClick={onRetry}
            disabled={isRetrying}
            style={{
              ...styles.button,
              ...(isRetrying ? styles.buttonDisabled : null),
            }}
          >
            {isRetrying ? "Učitavanje..." : "Pokušaj ponovno"}
          </button>
        )}
      </div>
    </div>
  );
};

export default SystemStatusScreen;
